/*
Carousel Prev
*/

class CarouselPrev extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("You need to have a child button to go to previous!");
    }
    this.addEventListener("click", (e) => {
      const carousel = e.target.closest("site-carousel");

      if (carousel) {
        carousel.previous();
      } else {
        console.error("<carousel-prev> needs to be a child of <site-carousel>");
      }
    });
  }
}

customElements.define("carousel-prev", CarouselPrev);

/*
Carousel Next
*/

class CarouselNext extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("You need to have a child button to go to next!");
    }

    this.addEventListener("click", (e) => {
      const carousel = e.target.closest("site-carousel");
      if (carousel) {
        carousel.next();
      } else {
        console.error("<carousel-next> needs to be a child of <site-carousel>");
      }
    });
  }
}

customElements.define("carousel-next", CarouselNext);

/*
Carousel Pager
*/

class CarouselPager extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const pagerButtons = Array.from(this.querySelectorAll("button"));

    if (!pagerButtons.length > 1) {
      console.warn("No need for a pager with only one item!");
    } else {
      pagerButtons[0].classList.add("active");
    }

    pagerButtons.forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        const carousel = e.target.closest("site-carousel");

        if (carousel) {
          carousel.slideTo(i);
        } else {
          console.error(
            "<carousel-pager> needs to be a child of <site-carousel>"
          );
        }
      });
    });
  }
}

customElements.define("carousel-pager", CarouselPager);

/*
 * Site Carousel
 */

class SiteCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const rawConfig = this.dataset.config
      ? JSON.parse(this.dataset.config)
      : { slidesPerView: 1, spaceBetween: 20, loop: true };

    let config = { ...rawConfig };

    this.swiper = new Swiper(`#${this.dataset.id} .swiper`, {
      ...config,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        bulletClass:
          "w-2 h-2 bg-black rounded-full opacity-20 transition-all duration-200",
        bulletActiveClass: "active",
      },
    });
    this.handleSlideChange();
    this.updateNavButtons();
    this.classList.remove("opacity-0");
  }

  previous() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  next() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  slideTo(i) {
    if (this.swiper) {
      this.swiper.slideTo(i);
    }
  }

  handleSlideChange() {
    const pagers = Array.from(this.querySelectorAll("carousel-pager"));

    if (this.swiper) {
      this.swiper.on("slideChange", () => {
        pagers.forEach((pager) => {
          const buttons = Array.from(pager.querySelectorAll("button"));
          const nextPager = buttons[this.swiper.realIndex];

          buttons.forEach((button) => button.classList.remove("active"));
          nextPager.classList.add("active");
        });

        this.updateNavButtons();
      });
    }
  }

  updateNavButtons() {
    const prevButtons = this.querySelectorAll("carousel-prev button");
    const nextButtons = this.querySelectorAll("carousel-next button");

    if (!this.swiper || this.swiper.params.loop) return;

    const isBeginning = this.swiper.isBeginning;
    const isEnd = this.swiper.isEnd;

    prevButtons.forEach((btn) => (btn.disabled = isBeginning));
    nextButtons.forEach((btn) => (btn.disabled = isEnd));
  }
}

customElements.define("site-carousel", SiteCarousel);

/*
Cart Toggle
*/

class CartToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("Cart toggle component should have a button as a child!");
    }

    this.addEventListener("click", (e) => {
      const cart = document.querySelector("site-cart");
      if (cart) {
        cart.toggleCart();
      }
    });
  }
}

customElements.define("cart-toggle", CartToggle);

/*
Cart Add
*/

class CartAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector("form").addEventListener("submit", async (e) => {
      e.preventDefault();

      const $id = e.target.querySelector('[name="id"]');
      const $qty = e.target.querySelector('[name="quantity"]');
      const $sellingPlan = e.target.querySelector('[name="selling_plan"]');
      const qty = $qty ? $qty.value : 1;
      const sellingPlan =
        $sellingPlan && !!$sellingPlan.value ? $sellingPlan.value : null;

      const action = this.dataset.action || "cart";

      const atcButton = this.querySelector('button[type="submit"]');
      const atcText = atcButton.innerHTML;
      const loader = document.createElement("div");
      loader.className = "loading-ring";
      loader.innerHTML = "<div></div><div></div><div></div><div></div>";

      atcButton.setAttribute("disabled", true);
      atcButton.style.minWidth = atcButton.offsetWidth + "px";
      atcButton.style.display = "flex";
      atcButton.style.alignItems = "center";
      atcButton.style.justifyContent = "center";
      atcButton.innerHTML = "";
      atcButton.appendChild(loader);

      if ($id) {
        const cart = document.querySelector("site-cart");
        const openCart = action === "cart";

        if (cart) {
          await cart.addVariantToCart($id.value, qty, sellingPlan, openCart);
        }

        atcButton.innerHTML = atcText;
        atcButton.style.minWidth = "";
        atcButton.style.display = "";
        atcButton.style.alignItems = "";
        atcButton.style.justifyContent = "";
        atcButton.removeAttribute("disabled");

        if (action === "checkout") {
          window.location.href = "/checkout";
        }
      }
    });
  }
}

customElements.define("cart-add", CartAdd);

/*
Update Quantity
*/

class UpdateQuantity extends HTMLElement {
  constructor() {
    super();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  connectedCallback() {
    this.addEventListener(
      "click",
      this.debounce(async (e) => {
        const cart = document.querySelector("site-cart");
        const idx = this.dataset.index;
        const ctx = this.dataset.ctx;
        const val =
          this.parentElement.querySelector(".curr-quantity").innerHTML;
        let nextVal = Number(val);

        if (ctx === "increment") {
          nextVal += 1;
        } else if (ctx === "decrement") {
          nextVal -= 1;
        }

        if (cart) {
          await cart.updateQuantity(idx, nextVal);
        }
      }, 300)
    );
  }
}

customElements.define("update-quantity", UpdateQuantity);

/*
Cart Update
*/

class CartUpdate extends HTMLElement {
  constructor() {
    super();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  connectedCallback() {
    this.addEventListener(
      "change",
      this.debounce(async (e) => {
        const cart = document.querySelector("site-cart");
        const idx = e.target.dataset.index;
        const val = e.target.value;

        if (cart) {
          await cart.updateQuantity(idx, val);
        }
      }, 300)
    );
  }
}

customElements.define("cart-update", CartUpdate);

/*
Cart Remove
*/

class CartRemove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", async (e) => {
      e.preventDefault();

      const cart = document.querySelector("site-cart");
      const idx = this.dataset.index;

      if (cart) {
        await cart.updateQuantity(idx, 0);
      }
    });
  }
}

customElements.define("cart-remove", CartRemove);

/*
Site Cart
*/

class SiteCart extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.isCustomer = this.dataset.isCustomer;
  }

  connectedCallback() {
    this.cart = document.querySelector(".site-cart");
    this.checkUrlForCartOpen();
  }

  checkUrlForCartOpen() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("cart_open") === "true") {
      this.openCart();
    }
  }

  openCart() {
    if (this.cart) {
      this.cart.classList.add("active");
    }
  }

  closeCart() {
    if (this.cart) {
      this.cart.classList.remove("active");
    }
  }

  toggleCart() {
    if (this.cart.classList.contains("active")) {
      this.closeCart();
    } else {
      this.openCart();
    }
  }

  getCartSections() {
    return [
      {
        section: "main-cart-items",
        selector: "#main-cart-items",
      },
      {
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
      {
        section: "main-cart-header",
        selector: "#main-cart-header",
      },
      {
        section: "header",
        selector: "#header",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  renderCartSections(sections) {
    const getSections = this.getCartSections();
    const sectionsArr = Object.keys(sections);

    sectionsArr.forEach((sectionKey) => {
      const activeSection = getSections.find((s) => s.section === sectionKey);
      const elToReplace = document.querySelector(activeSection.selector);
      if (elToReplace) {
        elToReplace.innerHTML = this.getSectionInnerHTML(
          sections[sectionKey],
          activeSection.selector
        );
      }
    });
  }

  buildConfig(body) {
    return {
      body: body,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
    };
  }

  addVariantToCart(id, quantity = 1, sellingPlan, openCart = true) {
    if (openCart) {
      this.openCart();
    }

    const items = [
      sellingPlan
        ? { id, quantity, selling_plan: sellingPlan }
        : { id, quantity },
    ];
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ items, sections });
    const config = this.buildConfig(body);

    return fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        this.renderCartSections(response.sections);

        return response;
      })
      .catch((e) => {
        // handle error
      });
  }

  addVariantToCartWithSubscription(variantId, quantity = 1, planId, openCart) {
    const sellingPlanId = planId;
    return this.addVariantToCart(variantId, quantity, sellingPlanId, openCart);
  }

  getCart() {
    return fetch("/cart.js").then((response) => response.json());
  }

  updateQuantity(line, quantity) {
    const items = Array.from(document.querySelectorAll(".cart-item"));
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ line, quantity, sections });
    const config = this.buildConfig(body);
    const item = items[line - 1];
    const loader = item.querySelector(".cart-loader");

    if (loader) {
      loader.classList.remove("opacity-0");
    }

    return fetch("/cart/change", config)
      .then((response) => response.json())
      .then(async (response) => {
        this.renderCartSections(response.sections);
        this.updateMemberVisibility();
        await this.removeMemberProductsIfNoBundleOrCustomer();

        if (loader) {
          loader.classList.add("opacity-0");
        }
      })
      .catch(() => {
        if (loader) {
          loader.classList.add("opacity-0");
        }
      });
  }
}

customElements.define("site-cart", SiteCart);

document.addEventListener("click", async function (e) {
  var btn = e.target.closest(".trio-buy-btn");
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  var handle = btn.dataset.productHandle;
  if (!handle) return;

  var btnSpan = btn.querySelector("span");
  var originalText = btnSpan ? btnSpan.textContent : "";
  var loader = document.createElement("div");
  loader.className = "loading-ring";
  loader.innerHTML = "<div></div><div></div><div></div><div></div>";
  btn.style.minWidth = btn.offsetWidth + "px";
  if (btnSpan) btnSpan.style.display = "none";
  btn.appendChild(loader);
  btn.style.pointerEvents = "none";

  try {
    var res = await fetch("/products/" + handle + ".js");
    if (!res.ok) return;
    var product = await res.json();
    var variant =
      product.variants.find(function (v) {
        return v.available;
      }) || product.variants[0];
    if (!variant) return;

    var cart = document.querySelector("site-cart");
    if (cart) {
      await cart.addVariantToCart(String(variant.id), 1, null, true);
    }
  } catch (err) {
    console.error("Add to cart error:", err);
  } finally {
    if (loader.parentNode) loader.parentNode.removeChild(loader);
    if (btnSpan) btnSpan.style.display = "";
    btn.style.minWidth = "";
    btn.style.pointerEvents = "";
  }
});

/*
Mobile Menu
*/

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.wrapper = null;
    this.trigger = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.wrapper = this.querySelector(".mobile-menu");
    this.trigger = document.querySelector(".burger-menu-js");

    this.trigger.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });
  }

  open() {
    this.wrapper.classList.remove("hidden");
    this.trigger.classList.add("active");
    this.isOpen = true;
  }

  close() {
    this.wrapper.classList.add("hidden");
    this.trigger.classList.remove("active");
    this.isOpen = false;
  }
}

customElements.define("mobile-menu", MobileMenu);

/*
Site Video
*/

class SiteVideo extends HTMLElement {
  connectedCallback() {
    const showVideoOverlay = this.dataset.showVideoOverlay === "true";

    this.playBtn = this.querySelector(".play-button-js");
    this.video = this.querySelector("video");

    if (this.playBtn) {
      this.playBtn.addEventListener("click", () => {
        this.pauseOtherVideos();
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      this.video.addEventListener("click", () => {
        this.pauseOtherVideos();
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      if (!showVideoOverlay) {
        this.video.addEventListener("ended", () => {
          this.playBtn.classList.remove("hidden");
        });

        this.video.addEventListener("pause", () => {
          this.playBtn.classList.remove("hidden");
        });

        this.video.addEventListener("play", () => {
          this.playBtn.classList.add("hidden");
        });
      }
    }

    if (this.dataset.stopOnObserve === "true") {
      this.stopOnObserve();
    } else {
      this.loadOnObserve();
    }
  }

  pauseOtherVideos() {
    document.querySelectorAll("site-video").forEach((videoComponent) => {
      const video = videoComponent.querySelector("video");
      if (video !== this.video && !video.paused) {
        video.pause();
      }
    });
  }

  stopOnObserve() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (!entry.isIntersecting) {
            video.pause();
          }
        });
      });

      videoObserver.observe(this.querySelector("video"));
    }
  }

  loadOnObserve() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.readyState !== 4) {
              [].slice
                .call(video.querySelectorAll("source"))
                .forEach((source) => {
                  if (source.dataset.src) {
                    source.src = source.dataset.src;
                  }
                });
              video.load();
            }
          }
        });
      });

      videoObserver.observe(this.querySelector("video"));
    }
  }
}

customElements.define("site-video", SiteVideo);

/*
Klaviyo Signup
*/

class KlaviyoSignup extends HTMLElement {
  constructor() {
    super();
    this.context = this.dataset.context;
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm(e);
      });
    }
  }

  async submitForm(e) {
    const error = this.querySelector(".error");
    const success = this.querySelector(".success");
    const emailOrPhone = this.form.querySelector('[type="text"]');
    const consent = this.form.querySelector('[type="checkbox"]');
    const submit = this.form.querySelector('[type="submit"]');
    const listId = this.dataset.listId;

    const fmtEmailOrPhone = emailOrPhone.value
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");
    const isAllNumbers = (str) => /^\d+$/.test(str);
    const isPhone = isAllNumbers(fmtEmailOrPhone);
    if (isPhone) {
      error.innerHTML = consent
        ? "Please opt in to SMS to continue."
        : "Please enter an email address.";
      if (!consent || !consent.checked) {
        error.classList.remove("hidden");
        return;
      }
    }

    error.innerHTML = "";
    error.classList.add("hidden");

    const submitText = submit.innerHTML;
    const submitWidth = submit.getBoundingClientRect().width;
    // submit.style.width = `${submitWidth}px`;
    submit.innerHTML = "...";

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: emailOrPhone.value,
                subscriptions: {
                  email: { marketing: { consent: "SUBSCRIBED" } },
                },
              },
            },
          },
        },
        ...(listId && {
          relationships: { list: { data: { type: "list", id: listId } } },
        }),
      },
    };

    try {
      const resp = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=RkSRbv`,
        {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            revision: "2025-01-15",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!resp.ok) {
        const errorData = await resp.json();
        throw new Error(
          errorData.errors?.[0]?.detail || "Klaviyo subscription request failed"
        );
      }

      this.form.reset();
      submit.innerHTML = submitText;
      success.classList.remove("hidden");
      emailOrPhone.blur();
    } catch (e) {
      error.classList.remove("hidden");
      error.innerHTML =
        e.message || "Oops, there was an error. Please try again.";
      submit.innerHTML = submitText;
    }
  }
}

customElements.define("klaviyo-signup", KlaviyoSignup);

/*
Product Quantity Selector
*/

class ProductQuantitySelector extends HTMLElement {
  connectedCallback() {
    this.quantityResult = this.querySelector(".quantity-js");
    const quantityMinus = this.querySelector(".quantity-minus-js");
    const quantityPlus = this.querySelector(".quantity-plus-js");

    quantityMinus.addEventListener("click", () => {
      if (parseInt(this.quantityResult.textContent) > 1) {
        this.quantityResult.textContent =
          parseInt(this.quantityResult.textContent) - 1;
      }

      const quant = this.querySelector('[name="quantity"]');
      if (quant) {
        quant.value = parseInt(this.quantityResult.textContent);
      }

      this.calculatePrices(+this.quantityResult.textContent);
    });

    quantityPlus.addEventListener("click", () => {
      this.quantityResult.textContent =
        parseInt(this.quantityResult.textContent) + 1;

      const quant = this.querySelector('[name="quantity"]');
      if (quant) {
        quant.value = parseInt(this.quantityResult.textContent);
      }
    });
  }
}

customElements.define("product-quantity-selector", ProductQuantitySelector);

/*
Accordion Item
*/

class AccordionItem extends HTMLElement {
  connectedCallback() {
    this.isFullRotation = this.dataset.fullRotation === "true";
    this.summaryOnly = this.dataset.summaryOnly === "true";
    this.startOpen = this.dataset.startOpen === "true";
    this.alwaysOpen = this.dataset.alwaysOpen === "true";

    this.icon = this.querySelector("svg");
    this.details = this.querySelector("details");
    this.content = this.querySelector(".content");
    this.summary = this.querySelector("summary");

    this.content.style.transition = "none";

    if (this.alwaysOpen || this.startOpen) {
      this.details.open = true;
      this.content.style.maxHeight = this.content.scrollHeight + "px";
      if (this.icon) this.icon.style.transform = "rotate(180deg)";
    } else {
      this.content.style.maxHeight = "0px";
    }

    if (this.alwaysOpen) {
      if (this.icon) this.icon.style.display = "none";
      if (this.summary) {
        this.summary.style.cursor = "default";
        this.summary.addEventListener("click", (e) => e.preventDefault());
      }
      return;
    }

    requestAnimationFrame(() => {
      this.content.style.transition = "max-height 0.3s ease";
    });

    const target = this.summaryOnly ? this.summary : this.details;
    target.addEventListener("click", (e) => {
      e.preventDefault();
      this.animateHeight();
    });
  }

  animateHeight() {
    const isOpen = this.details.open;

    if (isOpen) {
      if (this.isFullRotation) {
        this.icon.style.transform = "rotate(45deg)";
      } else {
        this.icon.style.transform = "rotate(0deg)";
      }
      this.content.style.maxHeight = "0px";
      setTimeout(() => {
        this.details.open = false;
      }, 300);
    } else {
      this.details.open = true;
      this.icon.style.transform = "rotate(180deg)";
      this.content.style.maxHeight = this.content.scrollHeight + "px";
    }
  }
}

customElements.define("accordion-item", AccordionItem);

/*
Site Modal
*/

class SiteModal extends HTMLElement {
  connectedCallback() {
    this.registerEvents();
    this.defineAutoOpenRoutine();
    this.modal = this.querySelector(".modal");
  }

  openModal() {
    if (this.modal) {
      document.body.classList.add("overflow-hidden");
      this.modal.classList.add("active");
    }
  }

  closeModal() {
    if (this.modal) {
      document.body.classList.remove("overflow-hidden");
      this.modal.classList.remove("active");
    }
  }

  registerEvents() {
    const opens = this.querySelectorAll(".modal-open");
    const closes = this.querySelectorAll(".modal-close");
    const triggerClass = this.dataset.trigger;
    const triggers = document.querySelectorAll(triggerClass);

    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          const agreeError = document.querySelector(".agree-error");
          if (agreeError) {
            agreeError.classList.add("hidden");

            if (e.target.classList.contains("select-subscription")) {
              if (!document.getElementById("agreeWithSubscription").checked) {
                agreeError.classList.remove("hidden");
                return;
              }
            }
          }

          this.openModal();
        });
      });
    }

    Array.from(opens).forEach((open) => {
      open.addEventListener("click", (e) => {
        this.openModal();
      });
    });

    Array.from(closes).forEach((close) => {
      close.addEventListener("click", (e) => {
        this.closeModal();
      });
    });
  }

  defineAutoOpenRoutine() {
    const autoOpenTimeout = this.dataset.autoOpenTimeout;
    if (
      autoOpenTimeout &&
      !localStorage.getItem("feno-subscribe") &&
      !sessionStorage.getItem("feno-subscribe")
    ) {
      setTimeout(() => {
        this.openModal();
      }, autoOpenTimeout);
    }
  }
}

customElements.define("site-modal", SiteModal);

/*
Tabs Content
*/

class TabsContent extends HTMLElement {
  connectedCallback() {
    const tabButtons = this.querySelectorAll("#tabs button");
    const contentBlocks = this.querySelectorAll("#contents > div");

    tabButtons.forEach((button, buttonIndex) => {
      button.addEventListener("click", () => {
        tabButtons.forEach((btn) => {
          btn.classList.remove("border-b-2", "border-white");
          btn.classList.add("opacity-40");
        });
        button.classList.add("border-b-2", "border-white");
        button.classList.remove("opacity-40");

        contentBlocks.forEach((content, contentIndex) => {
          if (buttonIndex === contentIndex) {
            content.classList.remove("absolute", "invisible", "opacity-0");
          } else {
            content.classList.add("absolute", "invisible", "opacity-0");
          }
        });
      });
    });
  }
}

customElements.define("tabs-content", TabsContent);

/*
Fifty Fifty Video
*/

class FiftyFiftyVideo extends HTMLElement {
  connectedCallback() {
    const veil = this.querySelector(".video-veil");
    const video = this.querySelector("video");

    this.addEventListener("click", (e) => {
      const playBtn = e.target.closest(".play-video");
      if (playBtn) {
        if (video.paused) {
          veil && veil.classList.add("opacity-0");
          video.play();
        } else {
          veil && veil.classList.remove("opacity-0");
          video.pause();
        }
      }
    });
  }
}

customElements.define("fifty-fifty-video", FiftyFiftyVideo);

/*
See More
*/

class SeeMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector(".button-see-more");
    const items = this.querySelectorAll(".see-more-item");

    if (!button || items.length === 0) return;

    button.addEventListener("click", () => {
      items.forEach((item) => {
        item.style.display = "block";
      });
      button.style.display = "none";
    });
  }
}

customElements.define("see-more", SeeMore);

/*
Product Subscribe
*/

class ProductSubscribe extends HTMLElement {
  constructor() {
    super();
    this.setupListeners = this.setupListeners.bind(this);
    this.setSellingPlan = this.setSellingPlan.bind(this);
    this.setOneTimePurchase = this.setOneTimePurchase.bind(this);
  }

  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    this.subscriptionRadio = this.querySelector("#subscribeRadio");
    this.subscribeBox = this.querySelector(".subscribe-box-js");

    this.oneTimeRadio = this.querySelector("#oneTimeRadio");
    this.oneTimeBox = this.querySelector(".one-time-box-js");

    this.sellingPlanId = this.dataset.sellingPlanId;
    this.sellingPlanInput = this.querySelector("#selling-plan-js");

    this.originalPrice = this.dataset.originalPrice;
    this.subscriptionPrice = this.dataset.subscriptionPrice;

    this.buttonPrice = this.querySelector(".button-price");

    if (this.subscriptionRadio) {
      this.subscriptionRadio.addEventListener("change", this.setSellingPlan);
    }

    if (this.oneTimeRadio) {
      this.oneTimeRadio.addEventListener("change", this.setOneTimePurchase);
    }

    this.setSellingPlan();
    this.setOneTimePurchase();
  }

  setSellingPlan() {
    if (this.subscriptionRadio && this.subscriptionRadio.checked) {
      this.sellingPlanInput &&
        (this.sellingPlanInput.value = this.sellingPlanId);

      this.subscribeBox.classList.remove("border-opacity-20");
      this.subscribeBox.classList.add("bg-light-gray");

      this.oneTimeBox.classList.add("border-opacity-20");
      this.oneTimeBox.classList.remove("bg-light-gray");

      if (this.buttonPrice && this.subscriptionPrice) {
        this.buttonPrice.textContent = this.subscriptionPrice;
      }
    }
  }

  setOneTimePurchase() {
    if (this.oneTimeRadio.checked) {
      this.sellingPlanInput && (this.sellingPlanInput.value = "");

      if (this.subscribeBox) {
        this.subscribeBox.classList.add("border-opacity-20");
        this.subscribeBox.classList.remove("bg-light-gray");
      }
      this.oneTimeBox.classList.remove("border-opacity-20");
      this.oneTimeBox.classList.add("bg-light-gray");

      if (this.buttonPrice && this.originalPrice) {
        this.buttonPrice.textContent = this.originalPrice;
      }
    }
  }

  getCurrencyAndFormat(value) {
    function formatCurrency(value, currency) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
      }).format(value / 100);
    }
    let currency = Shopify.currency.active;

    return formatCurrency(value, currency);
  }
}

customElements.define("product-subscribe", ProductSubscribe);

/*
Video Sound Toggle
*/

class VideoSoundToggle extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector(".heroVideo");
    const muteBtn = this.querySelector("#muteToggle");
    const iconMuted = this.querySelector("#icon-muted");
    const iconUnmuted = this.querySelector("#icon-unmuted");

    document.addEventListener("click", (e) => {
      if (muteBtn.contains(e.target)) {
        video.muted = !video.muted;
        iconMuted.classList.toggle("hidden", !video.muted);
        iconUnmuted.classList.toggle("hidden", video.muted);
      }
    });
  }
}

customElements.define("video-sound-toggle", VideoSoundToggle);

/*
Header Menu
*/

class HeaderMenu extends HTMLElement {
  connectedCallback() {
    const header = document.querySelector(".site-header");
    const input = header.querySelector(".search-input");

    this._handleClick = (e) => {
      const button = e.target.closest("button");

      if (button && button.matches(".toggle-search")) {
        header.classList.toggle("active");
        setTimeout(() => {
          header.classList.contains("active") ? input.focus() : input.blur();
        }, 100);
      }

      if (button && button.matches(".mobile-menu-toggle")) {
        const mobileMenu = document.querySelector(".mobile-menu");
        const menuIcons = button.querySelectorAll("svg");
        const isOpen = mobileMenu.classList.contains("opacity-100");

        document.body.classList.toggle("overflow-hidden", !isOpen);

        mobileMenu.classList.toggle("opacity-100");
        mobileMenu.classList.toggle("visible");
        mobileMenu.classList.toggle("opacity-0");
        mobileMenu.classList.toggle("invisible");

        menuIcons[0].classList.toggle("hidden");
        menuIcons[1].classList.toggle("hidden");
      }

      const link = e.target.closest("a");
      if (link && document.querySelector(".mobile-menu.opacity-100")) {
        const mobileMenu = document.querySelector(".mobile-menu");
        const toggleButton = document.querySelector(".mobile-menu-toggle");
        const menuIcons = toggleButton.querySelectorAll("svg");

        document.body.classList.remove("overflow-hidden");
        mobileMenu.classList.remove("opacity-100", "visible");
        mobileMenu.classList.add("opacity-0", "invisible");

        menuIcons[0].classList.remove("hidden");
        menuIcons[1].classList.add("hidden");
      }
    };

    this._handleKeydown = (e) => {
      if (e.key === "Escape") {
        header.classList.remove("active");
        setTimeout(() => input.blur(), 100);
      }
    };

    document.addEventListener("click", this._handleClick);
    document.addEventListener("keydown", this._handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleClick);
    document.removeEventListener("keydown", this._handleKeydown);
  }
}

customElements.define("header-menu", HeaderMenu);

class PackSizeSelector extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll(".pack-btn"));
    this.section = this.closest("[id^='product-detail-']");
    this.form = this.section
      ? this.section.querySelector("cart-add form")
      : null;

    this.buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.buttons.forEach((b) => {
          b.classList.remove("active", "border-white", "text-white");
          b.classList.add("border-white/30", "text-white/40");
        });
        btn.classList.add("active", "border-white", "text-white");
        btn.classList.remove("border-white/30", "text-white/40");

        var handle = btn.dataset.handle;
        if (handle) {
          this.loadProduct(handle);
        }
      });
    });
  }

  async loadProduct(handle) {
    try {
      var res = await fetch("/products/" + handle + ".js");
      if (!res.ok) return;
      var product = await res.json();
      var variant =
        product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];
      if (!variant || !this.form) return;

      var input = this.form.querySelector('[name="id"]');
      if (input) {
        input.value = variant.id;
      }

      var priceEl = this.section
        ? this.section.querySelector("[data-product-price]")
        : null;
      if (priceEl && typeof variant.price === "number") {
        priceEl.textContent = "$" + (variant.price / 100).toFixed(2);
      }
    } catch (err) {
      console.error("Pack size load error:", err);
    }
  }
}

customElements.define("pack-size-selector", PackSizeSelector);

(function () {
  var items = document.querySelectorAll(".fade-in");
  if (!items.length) return;
  if (!("IntersectionObserver" in window)) {
    items.forEach(function (item) {
      item.classList.add("is-visible");
    });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
  );
  items.forEach(function (item) {
    observer.observe(item);
  });
})();
